/**
 * Miscellaneous strings used in the check bot module
 */
export enum CheckBotModuleStrings {
  CUSTOM_CHECK_BOT_CONFIG = 'custom',
}
